import { render, staticRenderFns } from "./TheAdminCloneSpace.vue?vue&type=template&id=323db74f&"
import script from "./TheAdminCloneSpace.vue?vue&type=script&lang=js&"
export * from "./TheAdminCloneSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports